import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import Text from "./Text";

interface TabSelectorProps {
    variant?: "pill" | "link";
    tabs: TabType[];
    selectedTab: string;
    setSelectedTab: Dispatch<SetStateAction<string>>;
    hugContent?: boolean;
}

type TabType = {
    textKey: string;
    value: string;
};

const TabSelector = ({ variant = "link", tabs, selectedTab, setSelectedTab, hugContent = false }: TabSelectorProps) => {
    const { t } = useTranslation();

    return (
        <div className={`tab-selector-wrapper ${hugContent ? "hug-content" : ""} ${variant}-variant`.trim()}>
            {tabs.map((tab) => (
                <div className={`tab-wrapper ${selectedTab === tab.value ? "active" : ""}`.trim()} key={tab.value}>
                    <Text weight="semibold" className="tab" onClick={() => setSelectedTab(tab.value)}>
                        {t(tab.textKey)}
                    </Text>
                    <span className="line-bottom" />
                </div>
            ))}
        </div>
    );
};

export default TabSelector;
